/**
 * A step's own footer action (BLU-1376). Primary while the step is open,
 * secondary beside "Next" once the step is complete (see `pane-action.ts`).
 * `asChild` lets a step render a real link (the Shopify install link) with the
 * same look.
 */
import { forwardRef } from 'react';
import { Button, type ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { paneActionClass, usePaneActionTone } from './pane-action';

export const PaneActionButton = forwardRef<HTMLButtonElement, ButtonProps>(function PaneActionButton(
  { className, size = 'sm', ...props },
  ref,
) {
  const tone = usePaneActionTone();
  return (
    <Button
      ref={ref}
      size={size}
      data-tone={tone}
      className={cn(paneActionClass(tone), className)}
      {...props}
    />
  );
});
